export enum FeatureFlagActionType {
  CREATE_FEATURE_FLAG_FAILURE = '@@feature-flags/CREATE_FEATURE_FLAG_FAILURE_CLIENT',
  CREATE_FEATURE_FLAG_REQUEST = '@@feature-flags/CREATE_FEATURE_FLAG_REQUEST_CLIENT',
  CREATE_FEATURE_FLAG_SUCCESS = '@@feature-flags/CREATE_FEATURE_FLAG_SUCCESS_CLIENT',

  DELETE_FEATURE_FLAG_FAILURE = '@@feature-flags/DELETE_FEATURE_FLAG_FAILURE',
  DELETE_FEATURE_FLAG_REQUEST = '@@feature-flags/DELETE_FEATURE_FLAG_REQUEST',
  DELETE_FEATURE_FLAG_SUCCESS = '@@feature-flags/DELETE_FEATURE_FLAG_SUCCESS',

  DISABLE_FEATURE_FLAG_FAILURE = '@@feature-flags/DISABLE_FEATURE_FLAG_FAILURE',
  DISABLE_FEATURE_FLAG_REQUEST = '@@feature-flags/DISABLE_FEATURE_FLAG_REQUEST',
  DISABLE_FEATURE_FLAG_SUCCESS = '@@feature-flags/DISABLE_FEATURE_FLAG_SUCCESS',
  ENABLE_FEATURE_FLAG_FAILURE = '@@feature-flags/ENABLE_FEATURE_FLAG_FAILURE',

  ENABLE_FEATURE_FLAG_REQUEST = '@@feature-flags/ENABLE_FEATURE_FLAG_REQUEST',
  ENABLE_FEATURE_FLAG_SUCCESS = '@@feature-flags/ENABLE_FEATURE_FLAG_SUCCESS',
  GET_ALL_FEATURE_FLAGS_FAILURE = '@@feature-flags/GET_ALL_FEATURE_FLAGS_FAILURE',

  GET_ALL_FEATURE_FLAGS_REQUEST = '@@feature-flags/GET_ALL_FEATURE_FLAGS_REQUEST',
  GET_ALL_FEATURE_FLAGS_SUCCESS = '@@feature-flags/GET_ALL_FEATURE_FLAGS_SUCCESS',
  GET_FEATURE_FLAG_BY_UUID_FAILURE = '@@feature-flags/GET_ALL_FEATURE_FLAGS_FAILURE',

  GET_FEATURE_FLAG_BY_UUID_REQUEST = '@@feature-flags/GET_FEATURE_FLAG_BY_UUID_REQUEST',
  GET_FEATURE_FLAG_BY_UUID_SUCCESS = '@@feature-flags/GET_FEATURE_FLAG_BY_UUID_SUCCESS',
  TOGGLE_CREATE = '@@feature-flags/TOGGLE_CREATE',

  UPDATE_FEATURE_FLAG_FAILURE = '@@feature-flags/UPDATE_FEATURE_FLAG_FAILURE',
  UPDATE_FEATURE_FLAG_REQUEST = '@@feature-flags/UPDATE_FEATURE_FLAG_REQUEST',
  UPDATE_FEATURE_FLAG_SUCCESS = '@@feature-flags/UPDATE_FEATURE_FLAG_SUCCESS',
}
